/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import {
  type CategoryFormProps,
  type CategoryStatusList,
} from 'utils/TypeConfig';
import {useFormik} from 'formik';

import * as Yup from 'yup';
import {toast} from 'react-toastify';
import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {variables} from 'utils/constant';
import {useDispatch, useSelector} from 'react-redux';

import {phone} from 'phone';
import {type AppDispatch} from 'store';
import {setCountryCode} from 'slices/common/reducer';

const UserForm: React.FC<CategoryFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editCategory,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [status] = useState([
    {
      id: variables.ACTIVE_STATUS_ID,
      name: variables.ACTIVE_STATUS,
    },
    {
      id: variables.INACTIVE_STATUS_ID,
      name: variables.INACTIVE_STATUS,
    },
    {
      id: variables.SUSPEND_STATUS_ID,
      name: variables.SUSPEND_STATUS,
    },
  ]);

  const countryCode = useSelector(
    (state: any) => state.commonState.countryCode,
  );

  useEffect(() => {
    const fetchCountryCode = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getCountryCode();
        dispatch(setCountryCode(response?.data)); // Updates Redux store
      } catch (err) {
        console.error(err);
      }
    };

    if (!countryCode || countryCode.length === 0) {
      void fetchCountryCode();
    }
  }, [countryCode, dispatch]); // Re-run only if countryCode changes

  // const dubaiNumberRegex = /^(3|4|5|6|7|9|50|51|52|55|56)[0-9]{7}$/;

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name:
        editCategory?.first_name !== '' ? editCategory?.first_name : '',
      last_name: editCategory?.last_name !== '' ? editCategory?.last_name : '',
      email: editCategory?.email !== '' ? editCategory?.email : '',
      phone: editCategory?.phone !== '' ? editCategory?.phone : '',
      // gender: editCategory?.gender !== '' ? editCategory?.gender : '',
      gender:
        editCategory?.gender !== undefined ? String(editCategory?.gender) : '', // Ensure it's an empty string for new user

      status: editCategory?.status !== '' ? editCategory?.status : '',
      instagram_handle:
        editCategory?.instagram_handle !== ''
          ? editCategory?.instagram_handle
          : '',
      country_id:
        editCategory?.country_code !== '' ? editCategory?.country_code : '',
      country_code: editCategory?.country_id || '229', // Default ID for +971
      // selected_country_code:
      //   countryCode.find((item: {id: string}) => item.id == '229')
      //     ?.country_code || '+971', // Default value
      selected_country_code: editCategory?.country
        ? editCategory?.country?.country_code
        : '+971',
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required('First name is required'),
      // .matches(/^[A-Za-z]+$/, 'First name can only contain letters'),
      last_name: Yup.string().nullable(),
      // .required('Last name is required')
      // .matches(/^[A-Za-z]+$/, 'Last name can only contain letters'),
      // email: Yup.string().required('Email is required'),
      email: Yup.string().nullable(),
      phone: Yup.string()
        // .matches(
        //   dubaiNumberRegex,
        //   'Phone number must start with a valid Dubai prefix and contain 7 digits after the prefix.',
        // )
        .test(
          'custom-phone-validation',
          'Phone number is invalid.',
          function (value) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const {selected_country_code} = this.parent; // Get selected country code from Formik values

            if (!value) return false; // Ensure value exists
            return customFunction(value, selected_country_code); // Use the selected country code for validation
          },
        )
        .required('Phone number is required'),
      // gender: Yup.string().required('Gender is required'),
      status: Yup.number().required('Status is required'),
      // instagram_handle: Yup.string()
      //   .matches(
      //     /^[a-zA-Z0-9_.]{1,30}$/,
      //     'Instagram profile can only contain letters, numbers, underscores, and periods, and must be between 1 and 30 characters',
      //   )
      //   .required('Instagram profile is required'),
    }),
    onSubmit: async (values: any): Promise<void> => {
      console.log('🚀 ~ onSubmit: ~ values:', values);

      try {
        const formData = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email ? values.email : '',
          phone: values.phone,
          gender: values.gender,
          status: parseInt(values.status),
          country_id: Number(values.country_code),
          ...(editCategory?.id ? {id: editCategory?.id} : {}),
          // ...(editCategory?.id ? {status: parseInt(values.status)} : {}),
          instagram_handle: values.instagram_handle,
        };

        if (typeof values?.image !== 'string') {
          (formData as any).image = values?.image;
        }
        console.log('🚀 ~ onSubmit: ~ formData:', formData);
        try {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const response: any = editCategory?.id
            ? await ApiUtils.updateUser(formData)
            : await ApiUtils.addUser(formData);
          // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/strict-boolean-expressions
          if (setIsEditCategory) {
            setIsEditCategory((prev: boolean) => !prev);
          }
          if (setIsAddCategory) {
            setIsAddCategory((prev: boolean) => !prev);
          }
          handleClose();
          toast.success(response?.message);
          // void getCategoryList();
        } catch (error: any) {
          toast.error(error?.response?.data?.message);
        }
      } catch (err: any) {
        toast.error(err);
      }
    },
  });

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  // function customFunction(phoneNumber: string, code: string) {
  //   const status = phone(`+${code} ${phoneNumber}`);
  //   return status?.isValid;
  // }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function customFunction(phoneNumber: string, code: number) {
    const cleanedPhone = phoneNumber.replace(/\s+/g, '');

    // UAE landline area codes
    const landlineAreaCodes = ['2', '3', '4', '6', '7', '9'];

    // Check if UAE landline
    if (Number(code) === 971) {
      const areaCode = cleanedPhone.charAt(0);
      const isLandline =
        landlineAreaCodes.includes(areaCode) && /^\d{8}$/.test(cleanedPhone);

      if (isLandline) {
        console.log('📞 Validating as UAE landline:', isLandline);
        return true;
      }
    }

    // Use phone library for mobile or other countries
    const status = phone(`+${code} ${phoneNumber}`);
    console.log('📱 Validating with phone lib:', status);
    return status?.isValid;
  }

  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-first_name">
                  First Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.CategoryName} />
              </div>
              <Form.Control
                type="text"
                id="event-first_name"
                placeholder="Enter first name"
                name="first_name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.first_name || editCategory?.first_name
                    ? editCategory?.first_name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.first_name) &&
                    Boolean(validation.errors.first_name)
                  )
                }
              />
              {Boolean(validation.touched.first_name) &&
              Boolean(validation.errors.first_name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.first_name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-last-name">
                  Last Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.CategoryName} />
              </div>
              <Form.Control
                type="text"
                id="event-last-name"
                placeholder="Enter last Name"
                name="last_name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.last_name || editCategory?.last_name
                    ? editCategory?.last_name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.last_name) &&
                    Boolean(validation.errors.last_name)
                  )
                }
              />
              {Boolean(validation.touched.last_name) &&
              Boolean(validation.errors.last_name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.last_name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-email">
                  Email
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.CategoryName} />
              </div>
              <Form.Control
                type="text"
                id="event-email"
                placeholder="Enter email"
                name="email"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.email || editCategory?.email
                    ? editCategory?.email
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.email) &&
                    Boolean(validation.errors.email)
                  )
                }
              />
              {Boolean(validation.touched.email) &&
              Boolean(validation.errors.email) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.email}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className=" d-flex">
              <Form.Label htmlFor="phone-number">
                Phone number
                <span className="text-danger required-mark">*</span>
              </Form.Label>

              <TooltipWithInfoIcon text={tooltipMessage.CategoryName} />
            </div>
            <div className=" mb-1 d-flex">
              <Form.Select
                className="form-select"
                style={{width: 'fit-content'}}
                name="country_code"
                id="country_code"
                value={
                  validation.values.country_code ||
                  (editCategory?.country_id !== ''
                    ? editCategory?.country_id
                    : '')
                }
                onChange={e => {
                  const selectedId = e.target.value;
                  const selectedOption =
                    e.target.options[e.target.selectedIndex]; // Get the selected option

                  validation.setFieldValue('country_code', selectedId); // Store ID in Formik
                  validation.setFieldValue(
                    'selected_country_code',
                    selectedOption.getAttribute('data-country-code'),
                  ); // Store country_code directly
                }}>
                {countryCode?.map(
                  (
                    data: {
                      id: string;
                      name: string;
                      short_code: string;
                      country_code: number;
                    },
                    i: React.Key | null | undefined,
                  ) => (
                    <option
                      key={i}
                      value={data.id}
                      data-country-code={data.country_code}>
                      {data.short_code} (+{data.country_code})
                    </option>
                  ),
                )}
              </Form.Select>

              <Form.Control
                type="number"
                id="phone-number"
                placeholder="Enter phone number"
                name="phone"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.phone || editCategory?.phone
                    ? editCategory?.phone
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.phone) &&
                    Boolean(validation.errors.phone)
                  )
                }
                onWheel={e => {
                  e.currentTarget.blur();
                }} // Prevent mouse wheel input
              />
            </div>
            {Boolean(validation.touched.phone) &&
            Boolean(validation.errors.phone) ? (
              <Form.Control.Feedback className="required-mark" type="invalid">
                {validation.errors.phone}
              </Form.Control.Feedback>
            ) : null}
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex align-items-center">
                <Form.Label htmlFor="gender" className="me-2">
                  Gender
                  <span className="text-danger required-mark">*</span>
                </Form.Label>
                <TooltipWithInfoIcon text={tooltipMessage.CategoryName} />
              </div>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  id="male"
                  label="Male"
                  name="gender"
                  value="1"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  // checked={
                  //   validation?.values?.gender === 1 ||
                  //   editCategory?.gender === 1
                  // }
                  checked={
                    validation?.values?.gender === '1' ||
                    (editCategory?.gender === 1 && !validation?.values?.gender)
                  }
                  isInvalid={
                    !!(
                      Boolean(validation.touched.gender) &&
                      Boolean(validation.errors.gender)
                    )
                  }
                />
                <Form.Check
                  inline
                  type="radio"
                  id="female"
                  label="Female"
                  name="gender"
                  value="2"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  // checked={
                  //   validation?.values?.gender === 2 ||
                  //   editCategory?.gender === 2
                  // }
                  checked={
                    validation?.values?.gender === '2' ||
                    (editCategory?.gender === 2 && !validation?.values?.gender)
                  }
                  isInvalid={
                    !!(
                      Boolean(validation.touched.gender) &&
                      Boolean(validation.errors.gender)
                    )
                  }
                />
              </div>
              {Boolean(validation.touched.gender) &&
              Boolean(validation.errors.gender) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.gender}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.CategoryStatus} />
              </div>
              <Form.Select
                className="form-select"
                name="status"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('status', e.target.value)
                }
                value={
                  validation.values.status ||
                  (editCategory?.status !== '' ? editCategory?.status : '')
                }
                isInvalid={
                  !!(validation.touched.status && validation.errors.status)
                }>
                <option value=" ">Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.status) &&
              Boolean(validation.errors.status) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.status}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-email">
                  Instagram Profile
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.instagramHandle} />
              </div>
              <Form.Control
                type="text"
                id="event-instagram-handle"
                placeholder="Enter instagram profile"
                name="instagram_handle"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.instagram_handle ||
                  editCategory?.instagram_handle
                    ? editCategory?.instagram_handle
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.instagram_handle) &&
                    Boolean(validation.errors.instagram_handle)
                  )
                }
              />
              {Boolean(validation.touched.instagram_handle) &&
              Boolean(validation.errors.instagram_handle) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.instagram_handle}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12} className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button variant="dark" id="add-btn" type="submit">
                {editCategory?.id !== undefined ? 'Edit User' : 'Add User'}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default UserForm;
